import { render } from "./VideoList.vue?vue&type=template&id=936f2922&scoped=true&ts=true"
import script from "./videoListHelper.ts?vue&type=script&lang=ts"
export * from "./videoListHelper.ts?vue&type=script&lang=ts"

import "./VideoList.vue?vue&type=style&index=0&id=936f2922&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-936f2922"]])

export default __exports__